import { z } from 'zod';
import type { LightChannelDoc } from '@ledium/types';
import {
    nameSchema,
    descriptionSchema,
    dmxResolutionSchema,
    spectrogramPointSchema,
    csvDataPointSchema,
    spectrogramRangesSchema,
    CHANNEL_MIN,
    CHANNEL_MAX
} from './primitives.js';

type LightChannelInput = Omit<LightChannelDoc, '_id' | 'locked' | 'linked' | 'groupLock' | 'sed'> & { sed?: number };

export const lightChannelSchema: z.ZodType<LightChannelInput> = z.object({
    name: nameSchema,
    description: descriptionSchema,
    resolution: dmxResolutionSchema,
    channel: z.number().int().min(CHANNEL_MIN).max(CHANNEL_MAX),
    spectrogram: z.array(spectrogramPointSchema),
    zoneId: z.string().min(1),
    csvData: z.array(csvDataPointSchema),
    spectrogramRanges: spectrogramRangesSchema,
    sed: z.number().optional()
});
